<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <OnTableSSR :data="rliss" />
      </div>
    </div>
  </div>
</template>

<script>
import OnTableSSR from '@/components/ssr/OnTableSSR.vue'
import axios from 'axios';

export default {
  data: function() {return {
    rliss: {}
  }},

  name: 'OnSecteursSousRegions',
  components: {
    OnTableSSR,
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/sectors_subregions.php',
          { })
        .then(response => {
          // this.fss = response.data.fss;
          this.rliss = response.data;
        })
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
